import React, { useState } from "react";
import styles from "./NavigationMenu.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "antd";

const navItems = [
  { title: "Home", active: true, path: "/" },
  // { title: "Products & Services" },
  { title: "Reviews & Blogs", path: "reviews-and-blogs" },
  { title: "Bodyshop Potential", path: "/bodyshop-potential" },
  { title: "Case Studies", path: "/case-studies" },
  { title: "Clients", path: "/clients" },
  { title: "About", path: "/about-us" },
];

function NavigationMenu({ setIsVisible, navItems }) {
  const [selectedItem, setSelectedItem] = useState("Home");
  const navigate = useNavigate();

  return (
    <nav className={styles.menuContainer}>
      <div className={styles.logoContainer} onClick={() => setIsVisible(false)}>
        <img
          loading="lazy"
          src="/img/bodyshop/menu-close.svg"
          className={styles.logoImage}
          alt=""
        />
      </div>
      <ul className={styles.navList}>
        {navItems.map((item, index) => (
          <>
            {item.subMenu && item.subMenu?.length > 0 ? (
              <Menu
                mode="inline"
                items={[
                  {
                    key: index,
                    label: item.text,
                    children: item.subMenu?.map((page) => {
                      return {
                        key: page._id,
                        label: (
                          <>
                            <li
                              key={index}
                              onClick={() => {
                                setSelectedItem(page.name);
                                navigate(
                                  page?.path ||
                                    `/information-policy/${page?.slug}`
                                );
                                setIsVisible(false);
                              }}
                            >
                              <a
                                className={`${styles.navItem} ${
                                  selectedItem == page.name
                                    ? styles.navItemActive
                                    : ""
                                }`}
                              >
                                {page.name}
                              </a>
                            </li>
                            {/* <Link
              to={`/branch/${page.path}`}
              onClick={() => setSideMenuVisible(false)}
            >
              {page.name}
            </Link> */}
                          </>
                        ),
                      };
                    }),
                  },
                ]}
                className="filter-menu"
              />
            ) : (
              <li
                key={index}
                onClick={() => {
                  setSelectedItem(item.text);
                  navigate(item?.path);
                  setIsVisible(false);
                }}
              >
                <a
                  className={`${styles.navItem} ${
                    selectedItem == item.text ? styles.navItemActive : ""
                  }`}
                >
                  {item.text}
                </a>
              </li>
            )}
          </>
        ))}
      </ul>
      {/* <div className={styles.bookServiceContainer}>
        <button className={styles.bookServiceButton}>
          <span className={styles.bookServiceText}>Book Service</span>
          <img
            loading="lazy"
            src="/img/bodyshop/right-arrow-white.svg"
            className={styles.arrowImage}
            alt=""
          />
        </button>
      </div> */}
    </nav>
  );
}

export default NavigationMenu;
